import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CustomersServices } from "../services";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../../configuration/services';
import { HttpClient } from '@angular/common/http';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ProductListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'customers-elements-list',
  templateUrl: 'customers-elements-list.html',
})
export class CustomersElementsListPage {
  customer_uid: any;
  customer_list_all_elements = [];
  term: string = '';

  customer_name: any;
  customer_phone: any;
  elements_searchbar_text: string = '';
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'units', dir: 'asc' },
    { prop: 'price', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public http: HttpClient,
    public customersServices: CustomersServices) {
  }


  elements_array_tmp: any = [];
  elements_array_filtered: any = [];
  list_elements_array: any = [];



  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.customer_name = this.navParams.get('customer_name');
    this.customer_phone = this.navParams.get('customer_phone');
    this.customer_uid = this.navParams.get('customer_uid');
    this.elements_array_tmp = this.navParams.get('customer_list_all_elements');
    this.getListElements();
    loadingPopup.dismiss();
  }

  getListElements() {
    this.list_elements_array = this.elements_array_tmp;
    this.elements_array_filtered = this.elements_array_tmp;
    this.elementsSearch(this.elements_searchbar_text);
  }

  elementsSearch(value) {
    if (value) {
      this.elements_array_filtered = this.list_elements_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.elements_array_filtered = this.list_elements_array;
    }
  }

  onSort(event) {
    var elements_array = this.elements_array_filtered;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        } else {
          elements_array.sort((a, b) => b.name.toLowerCase().localeCompare(a.name.toLowerCase()));
        }
        break;
      case 'units':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.units - b.units);
        } else {
          elements_array.sort((a, b) => b.units - a.units);
        }
        break;
      case 'price':
        if (event.newValue == 'asc') {
          elements_array.sort((a, b) => a.price - b.price);
        } else {
          elements_array.sort((a, b) => b.price - a.price);
        }
        break;
    }

    this.elements_array_filtered = elements_array;
  }
}


// WEBPACK FOOTER //
// ./src/pages/customers/customers-elements-list/customers-elements-list.ts